import React from 'react';
var BackIcon = function BackIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.29468 15.2946C7.68422 15.6841 8.31578 15.6841 8.70531 15.2946C9.0946 14.9053 9.09489 14.2742 8.70595 13.8846L3.83 8.99992L15 8.99992C15.5523 8.99992 16 8.55221 16 7.99992C16 7.44764 15.5523 6.99992 15 6.99992L3.83 6.99992L8.70595 2.11524C9.09489 1.7256 9.0946 1.09453 8.70532 0.705237C8.31578 0.315702 7.68422 0.315702 7.29468 0.705237L0 7.99992L7.29468 15.2946Z",
    fill: "#323847"
  }));
};
export default BackIcon;